import { useEffect, useState } from 'react';

import { ACCESS_KEY_STATES, selectAccessKeyState } from '@/ducks/accessKeys';
import {
  selectCabinHoldIsReady,
  selectCalculateInvoice,
  selectIsCalculateInvoiceLoaded,
} from '@/ducks/pages/summary/selectors';
import useFlowType from '@/features/flowType/useFlowType';
import { useAppSelector } from '@/store';

const AK_STATUSES = [ACCESS_KEY_STATES.DETAIL, ACCESS_KEY_STATES.EMPTY];

const useCalculateInvoiceAndHoldIsPending = (initialValue?: boolean) => {
  const { isMNVV } = useFlowType();
  const accessKeyStatus = useAppSelector(selectAccessKeyState);
  const isLoading = useAppSelector(selectCalculateInvoice)?.isLoading;
  const isLoaded = useAppSelector(selectIsCalculateInvoiceLoaded);
  const isCabinHoldReady = useAppSelector(selectCabinHoldIsReady);
  const [isPending, setIsPending] = useState(!!initialValue);

  useEffect(() => {
    if (AK_STATUSES.includes(accessKeyStatus)) setIsPending(true);
  }, [accessKeyStatus]);

  useEffect(() => {
    if (isLoading) setIsPending(true);
  }, [isLoading]);

  useEffect(() => {
    if (isLoaded && isMNVV) setIsPending(false);
  }, [isLoaded, isMNVV]);

  useEffect(() => {
    if (isCabinHoldReady && !isMNVV) setIsPending(false);
  }, [isCabinHoldReady, isMNVV]);

  return isPending;
};

export default useCalculateInvoiceAndHoldIsPending;
